import React from 'react';
import { CursorFX, ScrollProgress } from './lib/motion';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Architecture from './components/Architecture';
import Footer from './components/Footer';

const App = () => {
  return (
    <>
      <ScrollProgress />
      <CursorFX />
      <Nav />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <Architecture />
      </main>
      <Footer />
    </>
  );
};

export default App;
